import { IsNotEmpty, IsObject } from 'class-validator';

export class SimulateOpticOddsResultDto {
	@IsObject()
	@IsNotEmpty()
	data: Record<string, unknown>;
}
